import { type EntityType } from 'core/domain/EntityType'
import { type ObjectValues } from 'core/utils/object'

import { type Account } from './Account'

export type Carrier = {
  id: string
  name: string
  mc?: string
  dot: string
  contractingRequirementsPasses: boolean
  accountId: string
  address: CarrierAddress
  dispatcherPhoneNumber?: string
  equipmentTypes: Array<CarrierEquipmentType>
  regions: Array<string>
  bipdInsurance?: number
  cargoInsurance?: number
  safetyPassed: boolean
  hasPlanner: boolean
  hasActiveDNU: boolean
  fleetSizeCategory: string
  status?: CarrierStatusType
  eldProviderId?: string
  quickpayEnabled: boolean
  bidEnabled: boolean
  bidProbability: boolean
  entityType: EntityType
}

export type CarrierEquipmentType = 'reefer' | 'dryvan' | 'flatbed'

export type CarrierAccount = {
  id: string
  name: string
  mcNumber: string
  dotNumber: string
  account: Account
  entityType?: EntityType
}

export const CarrierStatus = {
  New: 'new',
  Pending: 'pending',
  Ready: 'ready',
  Inactive: 'inactive',
} as const

export type CarrierStatusType = ObjectValues<typeof CarrierStatus>

export const CarrierDocumentsStatus = {
  Missing: 'missing',
  Accepted: 'accepted',
  UnderReview: 'under_review',
} as const

export type CarrierDocumentsStatusType = ObjectValues<typeof CarrierDocumentsStatus>

export type CarrierAddress = {
  street: string
  city: string
  state: string
  zip: string | null
  country: string
}
